module.exports = __webpack_public_path__ + "static/poster-6-72b60d9b19346ffb9c4d837e09985dff.jpg";